import MainLayout from 'Components/Layout/MainLayout';
import React, {useRef} from 'react';
import TableRender, {ProColumnsType, TableContext} from 'table-render';
import useTable from '../../../Utils/Hooks/useTable';
import Style from '../../Reptile/Website/index.module.scss';
import {Button, Space} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import DeleteConfirm from '../../../Components/DeleteConfirm';
import EditModal from './Components/EditModal';
import useModalHandler from '../../../Utils/Hooks/useModalHandler';
import {useMutation} from 'react-query';
import {Agent} from './service';
import {useDictAll} from '../../../Utils/Hooks/useDict';
import StatusTag from 'Components/StatusTag';
import LinkDrawer from './Components/LinkDrawer';

const Index = () => {
    const {tableInit} = useTable(Agent.list, {});
    const tableRef = useRef<TableContext>(null);

    function reload() {
        tableRef?.current?.refresh();
    }
    const editModal = useModalHandler({
        component: EditModal,
    });
    const linkDrawer = useModalHandler({
        component: LinkDrawer,
        type: 'drawer',
    });

    const onDelete = useMutation({
        mutationFn: Agent.remove,
        onSuccess: () => {
            reload();
        },
    });

    const toolBar = (
        <div className={Style.toolBar}>
            <Space>
                <Button
                    type="primary"
                    onClick={() =>
                        editModal.open({
                            onOk: () => {
                                editModal.close();
                                reload();
                            },
                        })
                    }
                    icon={<PlusOutlined />}>
                    新增
                </Button>
            </Space>
        </div>
    );

    const dict = useDictAll(['Tenant']);

    const columns: ProColumnsType<Agent.List> = [
        {
            title: '名称',
            dataIndex: 'name',
            width: 150,
        },
        {
            title: '编码',
            dataIndex: 'code',
        },
        {
            title: '租户',
            dataIndex: 'customerId',
            render: dict.Tenant.getName,
        },
        {
            title: '模型',
            dataIndex: 'model',
            width: 150,
        },
        {
            title: '最大Token',
            dataIndex: 'maxTokens',
            width: 150,
        },
        {
            title: '启用状态',
            dataIndex: 'status',
            width: 100,
            render: (text: boolean) => <StatusTag status={text} />,
        },
        {
            title: '操作',
            fixed: 'right',
            dataIndex: 'id',
            width: 160,
            align: 'center',
            render: (id: string) => (
                <Space>
                    <Button
                        size="small"
                        type="link"
                        onClick={() => {
                            linkDrawer.open({
                                agentId: id,
                            });
                        }}>
                        关联设置
                    </Button>
                    <Button
                        size="small"
                        type="link"
                        onClick={() => {
                            editModal.open({
                                id,
                                onOk: () => {
                                    editModal.close();
                                    reload();
                                },
                            });
                        }}>
                        修改
                    </Button>
                    <DeleteConfirm onSuccess={() => onDelete.mutate(id)}>
                        <Button size="small" type="link">
                            删除
                        </Button>
                    </DeleteConfirm>
                </Space>
            ),
        },
    ];

    return (
        <MainLayout.SpaceWrapper padding>
            <TableRender
                rowKey="id"
                ref={tableRef}
                loading={onDelete.isLoading}
                columns={columns}
                toolbarRender={toolBar}
                scroll={{x: 'max-content'}}
                {...tableInit()}
            />

            {editModal.render()}
            {linkDrawer.render()}
        </MainLayout.SpaceWrapper>
    );
};

export default Index;
